import { Component, OnInit , Input } from '@angular/core';
import { CartService } from '../../../services/apicart/cart.service';

@Component({
    selector: 'app-boxproduct',
    templateUrl: './boxproduct.component.html',
    styleUrls: ['./boxproduct.component.css']
})
export class BoxproductComponent implements OnInit {
    @Input('className') className;
    @Input('item') item:any;
    public cart:any
    constructor(public apiCart: CartService) { }

    ngOnInit() {
        this.cart={
            id: this.item.id,
            path:this.item.parent_link+'/'+this.item.link,
            name: this.item.name,
            images: this.item.images,
            price: (isNaN(this.item.price_sale) || this.item.price_sale >0)? this.item.price_sale:this.item.price_buy,
            amount: 1
        }
        
    }
    clickBox = (e) => {
       
    }
    addCart(){
        let data = this.apiCart.reduce();
        if (data[this.cart.id]) {
            let a = isNaN(+data[this.cart.id].amount) ? 1 : +data[this.cart.id].amount;
            this.cart.amount = +this.cart.amount+1;
        }
        this.apiCart.edit(this.cart, this.cart.id); 
    }

}



// WEBPACK FOOTER //
// ./src/app/frontend/modules/boxproduct/boxproduct.component.ts